// extracted by mini-css-extract-plugin
module.exports = {"form":"Comment_form__UvANj","input":"Comment_input__2xFmK","list":"Comment_list__2rVBR","disabled":"Comment_disabled__3u0cc"};